import { render, staticRenderFns } from "./Sede.vue?vue&type=template&id=0c59e641&scoped=true"
import script from "./Sede.vue?vue&type=script&lang=js"
export * from "./Sede.vue?vue&type=script&lang=js"
import style0 from "./Sede.vue?vue&type=style&index=0&id=0c59e641&prod&scoped=true&lang=css"
import style2 from "./Sede.vue?vue&type=style&index=2&id=0c59e641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c59e641",
  null
  
)

export default component.exports